"use strict";
exports.__esModule = true;
exports.validate = exports.objectProperties = exports.list = exports.optional = exports.oneOf = exports.object = exports.boolean = exports.string = void 0;
var lodash_1 = require("lodash");
var result_1 = require("./result");
var joinProperties_1 = require("./joinProperties");
var errors_1 = require("./errors");
exports.string = result_1.wrapWithResult('string', lodash_1.isString);
exports.boolean = result_1.wrapWithResult('boolean', lodash_1.isBoolean);
exports.object = result_1.wrapWithResult('object', lodash_1.isObject);
exports.oneOf = function (list) {
    return result_1.wrapWithResult("one of " + list.map(function (item) { return "\"" + item + "\""; }), function (value) {
        return list.includes(value);
    });
};
exports.optional = function (validate) { return function (value) {
    return lodash_1.isNil(value) ? result_1.toResult(true) : validate(value);
}; };
exports.list = function (validate) { return function (value) {
    if (!lodash_1.isArray(value)) {
        return result_1.toResult(false, 'array');
    }
    var failedValidationResults = value
        .map(function (el) {
        var result = validate(el);
        return (result.valid === false &&
            result_1.toResult(false, "array<" + result.expectedType + ">"));
    })
        .filter(Boolean);
    return failedValidationResults.length > 0
        ? failedValidationResults[0]
        : result_1.toResult(true);
}; };
exports.objectProperties = function (schema) { return function (value) {
    var valueTypeValidation = exports.object(value);
    if (!valueTypeValidation.valid) {
        return valueTypeValidation;
    }
    var expectedKeys = Object.keys(schema);
    var actualKeys = Object.keys(value);
    var unsupportedProperty = actualKeys.find(function (property) { return !expectedKeys.includes(property); });
    if (unsupportedProperty) {
        return result_1.toResult(false, undefined, unsupportedProperty);
    }
    var failedValidationResults = expectedKeys
        .map(function (property) {
        var validator = schema[property];
        var propertyValue = value[property];
        var result = validator(propertyValue);
        return (result.valid === false &&
            result_1.toResult(false, result.expectedType, joinProperties_1.joinProperties(property, result.nestedProperty), result.nestedProperty ? result.nestedValue : propertyValue));
    })
        .filter(Boolean);
    return failedValidationResults.length > 0
        ? failedValidationResults[0]
        : result_1.toResult(true);
}; };
exports.validate = function (propertyName, validator) { return function (value) {
    var _a = validator(value), valid = _a.valid, expectedType = _a.expectedType, nestedProperty = _a.nestedProperty, nestedValue = _a.nestedValue;
    if (!valid) {
        var propertyPath = joinProperties_1.joinProperties(propertyName, nestedProperty);
        var error = lodash_1.isUndefined(expectedType)
            ? errors_1.UnsupportedPropertyError(propertyPath)
            : errors_1.InvalidValueError(propertyPath, expectedType, nestedProperty ? nestedValue : value);
        throw error;
    }
}; };
//# sourceMappingURL=validate.js.map